import React from 'react';
import ReactDOM from 'react-dom/client';
import './utils/postMethodCompatibility.js';
import App from './App.jsx';
import './styles/index.css';
import './styles/SumairaEmilianoPrintableOverrides.css';
import './styles/SumairaEmilianoTimelineIcons.css';
import './styles/SumairaEmilianoOtherSizes.css';
import './styles/SumairaEmilianoExportSafe.css';
import './styles/EhlyianhaFaithGilOverflowFix.css';
import './styles/EhlyianhaFaithGilTypographyFix.css';
import './styles/EhlyianhaFaithGilLargeTypeVenueFix.css';
import './styles/EhlyianhaFaithGilBloomsVenueLayoutFix.css';
import './styles/EhlyianhaFaithGilCelebrationDetailsFix.css';
import './styles/EhlyianhaFaithGilCoverTypographyFix.css';
import './styles/EhlyianhaFaithGilCoverBackgroundPositionFix.css';
import './styles/EhlyianhaFaithGilExportSafe.css';
import './styles/PrintableCutScissorsFix.css';
import './utils/ehlyianhaExportImageAspectFix.js';
import './utils/ehlyianhaPdfCanvasFinalizer.js';
import './utils/ehlyianhaPdfNativeImageFinalizer.js';
import './utils/seatCheckerPrintableRedirects.js';
import './utils/petrineReminderAdminEnhancer.js';
import './utils/sumairaEntourageEnhancer.js';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
